import { environment } from '../../../environments/environment';

export class ApiRoutes {
  // services
  static publicApi = `${environment.apiUrl}/public`;
  static merchantApi = `${environment.apiUrl}/merchants`;
  static userApi = `${environment.apiUrl}/user`;
  static baseApi = `${environment.apiUrl}`;
  static merchantImageStorage = `${environment.imageStorageUrl}/merchants`;

  // endpoints

  // user
  static merchantRootAdminUsers = `${this.userApi}/merchant-root-admin-users`;
  static merchantAdminUsers = `${this.userApi}/merchant-admin-users`;

  // merchant
  static merchantBasicData = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/basic-data`;
  static getMerchantLogo = (merchantId: string) =>
    `${this.merchantImageStorage}/${merchantId}/logo`;
  static updateMerchantLogo = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/logo`;
  static merchantContactData = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/contacts`;
  static merchantSites = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/sites`;
  static merchantSitesId = (merchantId: string, siteId: string) =>
    `${this.merchantSites(merchantId)}/${siteId}`;
  static merchantMarketingData = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/marketing-data`;
  static merchantMarketingDataId = (
    merchantId: string,
    marketingDataId: string
  ) => `${this.merchantMarketingData(merchantId)}/${marketingDataId}`;
  static merchantSitesUpdate = (merchantId: string, siteId: string) =>
    `${this.merchantApi}/${merchantId}/sites/${siteId}`;
  static merchantCount = `${this.publicApi}/merchants_count`;
  static bannerLogoList = `${this.publicApi}/banner_logos`;
  static deleteMerchantProfileImage = (merchantId: string, pictureId: string) =>
    `${this.merchantApi}/${merchantId}/pictures/${pictureId}`;
  static getMerchantProfileImage = (merchantId: string, pictureId: string) =>
    `${this.merchantApi}/${merchantId}/pictures/${pictureId}`;
  static uploadMerchantProfileImage = (merchantId: string) =>
    `${this.merchantApi}/${merchantId}/pictures`;

  // product-catalog-service
  static containers = `${this.baseApi}/containers`;
  static packages = `${this.baseApi}/packages`;
  static products = `${this.baseApi}/products`;
  static containerSortiments = `${this.baseApi}/sortiments/containers`;
  static packagesSortiments = `${this.baseApi}/sortiments/packages`;
  static sortimentsProduct = `${this.baseApi}/sortiments/products`;
  static sortimentsProductEntries = (prodSortId: string) =>
    `${this.baseApi}/sortiments/products/${prodSortId}/entries`;
  static sortimentsContainer = `${this.baseApi}/sortiments/containers`;
  static sortimentsPackaging = `${this.baseApi}/sortiments/packages`;
  static statement = `${this.baseApi}/statements/actual`;
  static admin = `${this.baseApi}/admin`;
  static pricingApi = `${environment.apiUrl}/pricing`;
  static deliveryModeApi = `${environment.apiUrl}/delivery`;

  // container image
  static containerImages = `${ApiRoutes.baseApi}/container-images`;
  static uploadContainerImage = `${ApiRoutes.containerImages}/files`;
  static images = `${ApiRoutes.baseApi}/images`;

  // package image
  static packageImages = `${ApiRoutes.baseApi}/package-images`;
  static uploadPackageImage = `${ApiRoutes.packageImages}/files`;

  // search
  static productSearch = `${this.publicApi}/search/products`;
  static productBrands = `${this.publicApi}/search/products/brands`;
  static productSearchShops = (packagingUnitId: string) =>
    `${this.publicApi}/search/products/${packagingUnitId}/shops`;
  static productVariants = (packagingUnitId: string) =>
    `${this.publicApi}/search/products/${packagingUnitId}/variants`;
  static collectorVariants = (packagingUnitId: string) =>
    `${this.publicApi}/search/products/${packagingUnitId}/collectors`;
}
